import { Injectable } from '@angular/core';
import { CacheListener } from './@utils/cache-listener';
import { LocalStore } from './@data/LocalStore.class';
import { MemoryStore } from './@data/MemoryStore.class';
import { DataRegistryInspectorSession } from './@data/DataRegistryInspectorSession.class';
import { IpcService } from './services/ipc.service';
import { Subscription } from 'rxjs';

const sessionId = `${Date.now()}-${Math.floor(Math.random() * 9000) + 1000}`;

@Injectable({
  providedIn: 'root'
})
export class DataRegistryService {

  public memoryStores: Record<string, MemoryStore<any>> = {};
  public lsStorage: LocalStore = new LocalStore();
  public cacheListeners = new Set<CacheListener<any>>();
  public subscriptions = new Map<string, Subscription>();

  constructor(
    public ipc: IpcService
  ) { }

  init () {
    const subscription = this.ipc.onChannelMessage('ping').subscribe(async () => {
      this.ipc.send('pong', {
        id: sessionId,
        route: "/" + window.location.hash
      });
    });

    this.ipc.send('pong', {
      id: sessionId,
      route: "/" + window.location.hash
    });

    this.registerSubscription('inspector:ping', subscription);
  }

  send (type: string, data: any) {
    this.ipc.send(type, {
      ...data,
      id: sessionId
    });
  }

  cleanup () {

  }

  registerSubscription (id: string, subscription: Subscription) {
    this.subscriptions.set(id, subscription);
  }

  registerCacheListeners (...listeners: CacheListener<any>[]) {
      for (const listener of listeners) {
          this.cacheListeners.add(listener);
      }
  }

  async startInspector () {
    const session = new DataRegistryInspectorSession(this);
    session.startSession();
  }

}
